module.exports = __webpack_public_path__ + "static/media/menuBell.e897d559.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuBell.svg
// module id = 487
// module chunks = 0